/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './styles.css';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import cookies from 'react-cookies';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import br from 'date-fns/locale/pt-BR';
import ReactInputMask from 'react-input-mask';
import { LoaderIcon } from '../../components/Loader';
import api from '../../services/api';
import InputMask from '../../components/Form/InputMask';
import BackButton from '../../components/BackButton';
import information from '../../assets/icons/information.svg';
import {
  Container,
  Bottom,
  BtnLink,
  Header,
  Left,
  NewContractContent,
  Top,
  Body,
  ModalConfirm,
} from './styles';

registerLocale('br', br);
setDefaultLocale('br');

export interface dataServerDTO {
  created_at: string;
  creditor: dataTableInfo;
  debtor: dataTableInfo;
  due_date: string;
  total_value: string;
  id: number;
  percentage_value: string;
  status: string;
  updated_at?: string;
}

export interface dataTableInfo {
  affiliation_key: string;
  document: string;
  fantasy_name: string;
  id: number;
  legal_name: string;
  on_registry: boolean;
  stone_code: string;
}
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    borderRadius: '8',
    background: 'rgba(0,0,0,0)',
    border: 'none',
    padding: '-100px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
const NewContract: React.FC = () => {
  const [startDate, setStartDate] = useState<any>();
  const [date, setDate] = useState<string>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [percentage, setPercentage] = useState<string>();
  const [dataEdit, setDataEdit] = useState<dataServerDTO>();
  const [edition, setEdition] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    const temp = localStorage.getItem('proposalInfoClient');
    if (temp) {
      setDataEdit(JSON.parse(temp));
      const num = JSON.parse(temp).percentage_value.toLocaleString('pt-BR');
      setDate(
        `${JSON.parse(temp).due_date.substring(8, 10)}/${JSON.parse(
          temp,
        ).due_date.substring(5, 7)}/${JSON.parse(temp).due_date.substring(
          0,
          4,
        )}`,
      );
      setPercentage(num);
      setEdition(true);
    } else {
      setDataEdit(undefined);
      setEdition(false);
    }
    setLoadingData(false);
  }, []);

  async function handleSubmit(data: dataServerDTO) {
    setLoading(true);
    const dataTransform = `${date?.substring(6, 10)}-${date?.substring(
      3,
      5,
    )}-${date?.substring(0, 2)}`;
    const datas = {
      debtor_stone_code: data.debtor.stone_code,
      percentage_value: percentage?.replace(',', '.'),
      due_date: dataTransform,
      total_value: null,
    };
    if (data) {
      try {
        if (edition) {
          const response = await api.patch(
            `${
              process.env.REACT_APP_API_REQUEST_ENDPOINT
            }/v0/gps/merchants/${cookies.load(
              'external_stone_codes',
            )}/proposals/${dataEdit?.id}`,
            datas,
            {
              headers: {
                Authorization: `Bearer ${cookies.load('external_token')}`,
              },
            },
          );
          setLoading(false);
          localStorage.setItem(
            'proposalInfoClient',
            JSON.stringify(response.data),
          );
          history.push('/newcontract/review');
        } else {
          const response = await api.post(
            `${
              process.env.REACT_APP_API_REQUEST_ENDPOINT
            }/v0/gps/merchants/${cookies.load(
              'external_stone_codes',
            )}/proposals`,
            datas,
            {
              headers: {
                Authorization: `Bearer ${cookies.load('external_token')}`,
              },
            },
          );
          setLoading(false);
          localStorage.setItem(
            'proposalInfoClient',
            JSON.stringify(response.data),
          );
          history.push('/newcontract/review');
        }
      } catch (error) {
        setModalIsOpen(true);
      }
    }
    setLoading(false);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  return (
    <Container>
      <NewContractContent>
        <Header>
          <h3>{edition ? 'Editar Proposta' : 'Nova Proposta'}</h3>
          <BackButton adress="/" />
        </Header>
        <Body>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            overlayClassName="Overlay"
          >
            <ModalConfirm
              style={{
                background: '#FFCC00',
                border: '2px solid #FEDB4C',
              }}
            >
              <img
                src={information}
                alt="Informação"
                style={{ width: 80, height: 100 }}
              />
              <h3
                style={{ color: '#333333', fontSize: 36, textAlign: 'center' }}
              >
                Tivemos um
                <br />
                Problema
              </h3>
              <div
                style={{ color: '#333333', fontSize: 20, textAlign: 'center' }}
              >
                Não foi possível criar a
                <br />
                proposta, verifique os dados
                <br />
                informados e tente novamente.
              </div>
              <Bottom>
                <button
                  type="button"
                  style={{
                    width: 161,
                    height: 54,
                    background: '#fff',
                    color: '#333333',
                  }}
                  onClick={closeModal}
                >
                  Entendi
                </button>
              </Bottom>
            </ModalConfirm>
          </Modal>
          <Form onSubmit={handleSubmit}>
            <Top>
              <Left>
                <div>
                  <label style={{ color: '#343434' }}>Lojista</label>
                  <BtnLink>
                    {loadingData ? (
                      <input />
                    ) : (
                      <InputMask
                        name="debtor.stone_code"
                        required
                        mask="999999999"
                        defValue={dataEdit?.debtor.stone_code}
                        maskChar=""
                        placeholder=""
                        alwaysShowMask={false}
                        label="Informe o Stone Code do Lojista"
                      />
                    )}
                  </BtnLink>
                </div>
                <div>
                  <label style={{ color: '#343434' }}>Direcionamento</label>
                  <BtnLink>
                    {loadingData ? (
                      <input />
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 10,
                        }}
                      >
                        <label
                          style={{
                            color: '#333333',
                            fontSize: 15,
                            fontFamily: 'Roboto',
                            width: 300,
                            fontWeight: 300,
                          }}
                        >
                          Defina o percentual do direcionamento*
                        </label>
                        <input
                          style={{ width: 200 }}
                          placeholder="1,5"
                          value={percentage}
                          required
                          onChange={e => setPercentage(e.target.value)}
                        />
                      </div>
                    )}
                  </BtnLink>
                </div>
                <div>
                  <label style={{ color: '#343434' }}>Limites</label>

                  <div>
                    <BtnLink>
                      {loadingData ? (
                        <input />
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                          }}
                        >
                          <label
                            style={{
                              color: '#333333',
                              fontSize: 15,
                              fontFamily: 'Roboto',
                              width: 300,
                              fontWeight: 300,
                            }}
                          >
                            Data limite da Proposta*
                          </label>
                          <div className="inputGroupIcon">
                            <ReactInputMask
                              mask="99/99/9999"
                              value={date}
                              placeholder="31/12/2021"
                              className="inputWithIcon"
                              alwaysShowMask={false}
                              maskChar=""
                              onChange={e => {
                                setDate(e.target.value);
                              }}
                            />
                            <div
                              style={{
                                width: 1,
                                height: 30,
                                background: '#96a0af',
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                setShowCalendar(true);
                              }}
                            >
                              <FontAwesomeIcon
                                className="iconButton"
                                icon={faCalendarAlt}
                              />
                            </button>
                          </div>
                          <div
                            className="calendarClass"
                            style={{ display: showCalendar ? 'flex' : 'none' }}
                          >
                            <DatePicker
                              onClickOutside={() => {
                                setShowCalendar(false);
                              }}
                              required
                              selected={startDate}
                              inline
                              value={date}
                              adjustDateOnChange
                              dateFormat="dd/MM/yyyy"
                              onChange={(dateTemp: any) => {
                                if (dateTemp) {
                                  setDate(
                                    dateTemp.toLocaleString('pt-BR', {
                                      day: 'numeric',
                                      month: 'numeric',
                                      year: 'numeric',
                                    }),
                                  );
                                  setStartDate(dateTemp);
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </BtnLink>
                  </div>
                </div>
              </Left>
            </Top>
            {!loading ? (
              <Bottom>
                <button type="submit">Continuar</button>
              </Bottom>
            ) : (
              <Bottom>
                <LoaderIcon />
              </Bottom>
            )}
          </Form>
        </Body>
      </NewContractContent>
    </Container>
  );
};
export default NewContract;
